import { render, staticRenderFns } from "./userfeedback-add-or-update.vue?vue&type=template&id=1daccc96"
import script from "./userfeedback-add-or-update.vue?vue&type=script&lang=js"
export * from "./userfeedback-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports